<div class="flex flex-col gap-4 h-full bg-primary justify-center items-center">
  <h1 class="flex items-center gap-2 text-6xl text-white" i18n>
    404 Not Found
  </h1>
  <p class="text-white text-lg max-w-prose text-center" i18n>
    Oops! We couldn't find the link you're looking for. Please check the link
    for any typos or contact us for help via
    <a href="mailto:info&#64;skillz.be">info&#64;skillz.be</a>
    .
  </p>
</div>
